import { render, staticRenderFns } from "./MainNavigationItem.vue?vue&type=template&id=5d82d607&scoped=true"
import script from "./MainNavigationItem.vue?vue&type=script&lang=ts"
export * from "./MainNavigationItem.vue?vue&type=script&lang=ts"
import style0 from "./MainNavigationItem.vue?vue&type=style&index=0&id=5d82d607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82d607",
  null
  
)

export default component.exports